export interface IOrderItem {
  orderItemId: string;
  skuCode: string;
  uom: string;
  orderedQty: number;
  finalQtyWithVariance: number;
  finalQty: number;
  productName: string;
  productImage: string;
  color: string;
  packetDescription: string;
  suffix: string;
  perPcWeight: number;
  pieces: number | null;
  finalPieces: number | null;
  grades: string | null;
  notes: string | null;
}

export interface IOrderAddress {
  id: number;
  street: string;
  city: string;
  cityId: number;
  state: string;
  pincode: string;
  landmark: string;
  addressLine1: string;
  addressLine2: string;
  latitude: string;
  longitude: string;
  societyId: number;
  society: string;
  floor: string;
  house: string;
  sector: string | null;
  tower: string | null;
  isVerified: boolean;
  verificationStatus: number;
  mapFormattedAddress: string | null;
  deliveryInstructions: string | null;
}

export interface IContactDetails {
  name: string;
  phone: string;
}

export interface IUserActionInfo {
  updatedBy: number;
  name: string;
  updatedAt: string;
  images: string[] | null;
}

export interface IOrderMetadata {
  address: IOrderAddress;
  customerId: string;
  contactDetails: IContactDetails;
  displayOrderId: string;
  slotId: number;
  pickerInfo: IUserActionInfo | null;
  qaInfo: IUserActionInfo | null;
  packerInfo: IUserActionInfo | null;
  dispatcherInfo: IUserActionInfo | null;
  supervisorInfo: IUserActionInfo | null;
  cancelledByInfo: IUserActionInfo | null;
  runnerInfo: IUserActionInfo | null;
  trayCodes?: (string | number)[];
  notes: string | null;
  orderCount: number;
  isSkippingDelivery: boolean;
  isVip: boolean;
  dockNumber: string | null;
  appVersion: string;
  isCod: boolean | null;
  societyVerified: boolean;
  packingInstructions: string | null;
  deliveryInstructions: string | null;
}

export interface ITrayOrder {
  id: string;
  orderId: string;
  storeId: number;
  deliveryDate: string;
  slot: string;
  status: string;
  orderItems: IOrderItem[];
  metadata: IOrderMetadata;
  sequenceNo: number;
  batchId: number;
  color: string;
  supervisorApproved: boolean;
  totalCount: number | null;
  societyId: number;
  cityId: number;
}

export const normalizeTrayCodes = (
  metadata?: Pick<IOrderMetadata, "trayCodes"> | null
): string[] => {
  if (!metadata?.trayCodes?.length) return [];

  return metadata.trayCodes.map((value) => String(value));
};
